import script from "./AddCoach.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCoach.vue?vue&type=script&setup=true&lang=js"

import "./AddCoach.vue?vue&type=style&index=0&id=617bc7e8&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-617bc7e8"]])

export default __exports__